import React, { Component } from 'react';
import { compose, graphql } from 'react-apollo';
import _get from 'lodash/get';
import Grid from '@material-ui/core/Grid';

import gqlQueryGetAppFeatures from 'graphql/queries/get-app-features';
import gqlQueryGetAppFlags from 'graphql/queries/get-app-flags';
import Loader from 'components/theme/loader';
import FeatureListGrid from 'components/features/feature-list/feature-list-grid';
import FeatureModifier from 'components/features/feature-modifier';
import ErrorBoundry from 'components/error-handler/error-boundry';
import PageHeader from 'components/page-header';
import Content from 'components/theme/content';
import { actions } from 'app-constants';

class FeatureList extends Component {
  state = {
    openFeatureModifier: false
  };

  onEdit = (event) => {
    const state = this.prepareStateToUpdateFeature(event.currentTarget.dataset);
    this.setState({
      ...state,
      modifierAction: actions.FEATURE_EDIT
    });
  };

  onAdd = () => {
    this.setState({
      openFeatureModifier: true,
      featureToModify: {},
      flagToModify: {},
      modifierAction: actions.FEATURE_ADD
    });
  };

  onDelete = (event) => {
    const state = this.prepareStateToUpdateFeature(event.currentTarget.dataset);
    this.setState({
      ...state,
      modifierAction: actions.FEATURE_DELETE
    });
  };

  onToggle = (event) => {
    const state = this.prepareStateToUpdateFeature(event.currentTarget.dataset);
    this.setState({
      ...state,
      modifierAction: actions.FEATURE_TOGGLE
    });
  };

  getFeatures() {
    const {
      queryGetAppFeatures: { listFeatures }
    } = this.props;

    return (listFeatures && listFeatures.items) || [];
  }

  getFlags() {
    const {
      queryGetAppFlags: { listFlags }
    } = this.props;

    return (listFlags && listFlags.items) || [];
  }

  closeFeatureModifier = () => {
    this.setState({
      openFeatureModifier: false,
      featureToModify: null,
      flagToModify: null
    });
  };

  prepareStateToUpdateFeature(dataset) {
    const { feature, flag } = dataset;
    const featuresList = this.getFeatures();
    const flagsList = this.getFlags();

    return {
      openFeatureModifier: true,
      featureToModify: featuresList.find((f) => f.uId === feature),
      flagToModify: flagsList.find((f) => f.uId === flag)
    };
  }

  isLoding() {
    const featuresLoading = _get(this.props, 'queryGetAppFeatures.loading');
    const flagsLoading = _get(this.props, 'queryGetAppFlags.loading');
    return featuresLoading || flagsLoading;
  }

  isError() {
    const featuresError = _get(this.props, 'queryGetAppFeatures.error');
    const flagsError = _get(this.props, 'queryGetAppFlags.error');
    return featuresError || flagsError;
  }

  render() {
    if (this.isLoding()) return <Loader />;

    const error = this.isError();

    if (error) {
      return null;
    }

    const featuresList = this.getFeatures();
    const flagsList = this.getFlags();

    const {
      openFeatureModifier,
      featureToModify,
      flagToModify,
      modifierAction
    } = this.state;

    const { match } = this.props;

    return (
      <>
        <PageHeader title="Features" />
        <Content>
          <Grid container>
            <Grid item xs={12}>
              <FeatureListGrid
                featuresList={featuresList}
                flagsList={flagsList}
                onEdit={this.onEdit}
                onAdd={this.onAdd}
                onDelete={this.onDelete}
                onToggle={this.onToggle}
              />

              <ErrorBoundry>
                {openFeatureModifier && (
                  <FeatureModifier
                    onClose={this.closeFeatureModifier}
                    open={openFeatureModifier}
                    feature={featureToModify}
                    flag={flagToModify}
                    action={modifierAction}
                    appId={match.params.appId}
                    env={match.params.env}
                  />
                )}
              </ErrorBoundry>
            </Grid>
          </Grid>
        </Content>
      </>
    );
  }
}

export default compose(
  graphql(gqlQueryGetAppFeatures, {
    name: 'queryGetAppFeatures',
    options: ({ match }) => ({
      variables: {
        appId: match.params.appId
      }
    })
  }),
  graphql(gqlQueryGetAppFlags, {
    name: 'queryGetAppFlags',
    options: ({ match }) => ({
      variables: {
        appId: match.params.appId,
        environment: match.params.env
      }
    })
  })
)(FeatureList);
